import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SavePeopleService } from './save-people.service';
import { ServiceManagerService } from '../service-manager.service';
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';
import { HttpMethod } from 'src/constants/constant';

@Component({
  selector: 'app-save-people',
  templateUrl: './save-people.component.html',
  styleUrls: ['./save-people.component.scss']
})
export class SavePeopleComponent implements OnInit {

  language: any = "";
  interest: any = "";
  defaultOption: any = ["language", "interest"]
  defaultLanguages: any = []
  routerState: any = {}
  copyDefaultLanguages = JSON.parse(JSON.stringify(this.defaultLanguages))
  defaultInterest: any = []
  currentUserId:any;
  copyDefaultInterest = JSON.parse(JSON.stringify(this.defaultInterest))
  resendCode: any = "";
  isUserActive: any;
  interestControl = new FormControl();
  languageControl = new FormControl()
  languageOptions: Observable<string[]> = new Observable();
  interestOptions: Observable<string[]> = new Observable()
  constructor(public userForm: SavePeopleService, private serviceManager: ServiceManagerService, 
    private router: Router, public location: Location) {
    this.setDefaultOptions();
    var currentRoute = this.router.url.split("?")[0]
    this.routerState = this.router.getCurrentNavigation()?.extras?.state;
    if(currentRoute === "/update-people"){
      if(this.routerState?.user_id){
        this.currentUserId = this.routerState.user_id
        this.getUserDetails({ user_id : this.currentUserId}).then((data: any)=>{
          this.refreshInterests()
          this.refreshLanguage()
        })
      }
      else{
        router.navigate(['/people'])
      }
    }
    else{
      this.userForm.resetForm()
      userForm.role = "Mentor"
    }
   }

  ngOnInit(): void {
  }
  private _filterLanguage(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.defaultLanguages.filter((option : any) => option.toLowerCase().includes(filterValue));
  }

  private _filterInterest(value: string): string[] {
    const filterValue = value.toLowerCase();
    
    return this.defaultInterest.filter((option: any) => option.toLowerCase().includes(filterValue));
  }

  saveUser(){
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: true,
      createLoaderAction: true
    }
    var body = {
      "first_name": this.userForm.firstName,
      "last_name": this.userForm.lastName,
      "dob": new Date(this.userForm.userDob).toLocaleDateString('en-gb'),
      "email": this.userForm.email,
      "gender": this.userForm.gender,
      "city": this.userForm.city,
      "languages": this.userForm.languages,
      "sexuality": this.userForm.sexuality,
      "interests": this.userForm.interests,
      "about": this.userForm.about,
      "role": this.userForm.role
    }
    this.serviceManager.CallBackendServiceAPI('create-user', body, HttpMethod.POST, customOptions).subscribe( (data: any)=>{
      if(data){
        this.navToBack()
      }
    })
  }

  updateUser(){
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: true,
      createLoaderAction: true
    }
    var body = {
      "first_name": this.userForm.firstName,
      "last_name": this.userForm.lastName,
      "dob": new Date(this.userForm.userDob).toLocaleDateString('en-gb'),
      "email": this.userForm.email,
      "gender": this.userForm.gender,
      "city": this.userForm.city,
      "languages": this.userForm.languages,
      "sexuality": this.userForm.sexuality,
      "interests": this.userForm.interests,
      "about": this.userForm.about,
      "role": this.userForm.role,
      "user_id": this.currentUserId
    }
    this.serviceManager.CallBackendServiceAPI('update-user', body, HttpMethod.POST, customOptions).subscribe( (data: any)=>{
      console.log(data);
      if(data){
        this.navToBack()
      }
    })
  }

  addLanguage(){
    if(this.language.trim()){
      this.userForm.languages.push(this.language)
      this.refreshLanguage()
      this.language = ""
    }
  }

  removeLanguage(index: any){
    this.userForm.languages.splice(index, 1)
    this.refreshLanguage()
  }

  refreshLanguage(){
    console.log(this.userForm.languages, this.defaultLanguages)
    this.defaultLanguages = this.copyDefaultLanguages.filter((lang: any) => this.userForm.languages.indexOf(lang) < 0)
    console.log(this.userForm.languages, this.defaultLanguages)
    this.languageOptions = this.languageControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterLanguage(value))
    )
  }
  addInterest(){
    if(this.interest.trim()){
      this.userForm.interests.push(this.interest)
      this.refreshInterests()
      this.interest = ""
    }
  }

  removeInterest(index: any){
    this.userForm.interests.splice(index, 1)
    this.refreshInterests()
  }

  refreshInterests(){
    this.defaultInterest = this.copyDefaultInterest.filter((interest: any) => this.userForm.interests.indexOf(interest) < 0)
    this.interestOptions = this.interestControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterInterest(value))
    )
  }

  isUserFormValid(){
    var excludedparams = ['sexuality', 'createdAt', 'about', 'interests']
    for(let val in this.userForm){
      if(!this.serviceManager.isFilled(this.userForm[val as keyof SavePeopleService]) && !excludedparams.includes(val))
        return false
    }
    return true
  }

  setDefaultOptions(){
    var body = {
      "default_options" : this.defaultOption
    }
    this.getDefaultOptions(body).then((data : any)=>{
      this.defaultLanguages = data.language
      this.defaultInterest = data.interest
      this.copyDefaultLanguages = JSON.parse(JSON.stringify(this.defaultLanguages))
      this.copyDefaultInterest = JSON.parse(JSON.stringify(this.defaultInterest))
      this.languageOptions = this.languageControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filterLanguage(value))
      )
      this.interestOptions = this.interestControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filterInterest(value)),
      );
    }).catch(error => {
      console.log("Failed to fetch default options", error)
    })
  }

  getDefaultOptions(body: any){
    return new Promise((resolve)=>{
      this.serviceManager.CallBackendServiceAPI('get-default-option', body).subscribe( (data: any)=>{
        resolve(data.response)
      })
    })
  }

  getUserDetails(body: any){
    return new Promise( (resolve) => {
      this.serviceManager.CallBackendServiceAPI('user-details', body).subscribe( (data: any)=>{
        this.userForm = data.user_detail
        this.userForm.createdAt = new Date(this.userForm.createdAt).toLocaleDateString("en-US")
        this.userForm.editUser = true;
        this.isUserActive = data.user_detail.isActivate
        resolve(data)
      })
    })
  }

  navToBack(){
    this.router.navigate([".."]);
  }
}
